<app-loader></app-loader>
<!-- TODO: Reactivar chat en un futuro-->
<!--<app-chat-worker-background></app-chat-worker-background>-->
<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>
